import { ExpireAt } from "@interfaces/expire-at"

export const isTokenExpired = (expireAt: ExpireAt) => {
  if (!expireAt) return true
  const timeNow = new Date().toISOString()

  return timeNow > expireAt
}
